module.exports = "<div class=\"cartItemMessage--missedPromotion-heading\">\r\n    <wow-setting setting-group=\"Trolley\" setting-name=\"ProductPromoMessage\"></wow-setting>\r\n</div>\r\n<a ng-href=\"{{$ctrl.inlineMessage.message.promotionLink}}\" class=\"cartItemMessage--missedPromotion-description\">\r\n    {{$ctrl.inlineMessage.message.promotionDescription}}\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cartitemmessages/missed-promotion.html
// module id = 171
// module chunks = 0 1